<template>
  <form @submit="handleSubmit">
    <div :class="this.fieldClass()">
      <label class="field-label">{{ label }}</label>
      <div :id="`payment-element-${key}`" class="stripe-card"></div>
      <label id="payment-validation" class="field-status"></label>
    </div>
    <slot></slot>
  </form>
</template>
<script>
import { loadStripe } from "@stripe/stripe-js";
import { generate } from "shortid";

export default {
  props: {
    onSubmit: Function,
    isPaymentRequired: Boolean,
    fieldIsComplete: Function,
    label: String,
  },
  data() {
    return {
      stripe: null,
      stripeElements: null,
      paymentElement: null,
      publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
      key: generate(),
    };
  },
  beforeDestroy: async function () {
    this.paymentElement?.unmount();
  },
  beforeMount: async function () {
    this.stripe = await loadStripe(this.publishableKey);
    this.stripeElements = this.stripe.elements();

    this.createCardElement();
  },
  watch: {
    isPaymentRequired(newValue) {
      if (!newValue) {
        this.paymentElement.clear();
      }
    },
  },
  methods: {
    fieldClass() {
      let className = "field";

      if (!this.isPaymentRequired) {
        className += " || " + "disabled";
      }

      return className;
    },
    createCardElement() {
      this.paymentElement = this.stripeElements.create("card", {
        hidePostalCode: true,
        style: this.cardElementStyle(),
      });

      const { fieldIsComplete, key } = this;

      this.paymentElement.on("change", function (event) {
        const displayError = document.getElementById("payment-validation");

        if (event.error) {
          displayError.textContent = event.error.message;
          fieldIsComplete(false);
        } else if (event.complete) {
          fieldIsComplete(true);
        } else {
          displayError.textContent = "";
          fieldIsComplete(false);
        }
      });

      this.paymentElement.mount(`#payment-element-${key}`);
    },
    handleSubmit(event) {
      const { onSubmit, stripe, paymentElement } = this;

      if (event) {
        event.preventDefault();
      }

      onSubmit(stripe, paymentElement);
    },
    cardElementStyle() {
      return {
        base: {
          backgroundColor: "#FFF",
          color: "#31325F",
          iconColor: "#666EE8",
          fontWeight: 300,
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSize: "16px",
          "::placeholder": {
            color: "#878787",
          },
        },
      };
    },
  },
};
</script>
